import { render, staticRenderFns } from "./IconSetting.vue?vue&type=template&id=01d119f0&"
import script from "./IconSetting.vue?vue&type=script&lang=js&"
export * from "./IconSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports